// Badge component for status, plan labels, etc.
const variants = {
  active: "bg-emerald-500/15 text-emerald-400 border border-emerald-500/25",
  out_of_stock: "bg-rose-500/15 text-rose-400 border border-rose-500/25",
  inactive: "bg-gray-600/20 text-gray-400 border border-gray-600/25",
  featured: "bg-amber-500/15 text-amber-400 border border-amber-500/25",
  Premium: "bg-amber-500/15 text-amber-400 border border-amber-500/25",
  Advanced: "bg-violet-500/15 text-violet-400 border border-violet-500/25",
  Free: "bg-gray-600/20 text-gray-400 border border-gray-600/25",
  order: "bg-blue-500/15 text-blue-400 border border-blue-500/25",
  review: "bg-emerald-500/15 text-emerald-400 border border-emerald-500/25",
  system: "bg-violet-500/15 text-violet-400 border border-violet-500/25",
  promo: "bg-amber-500/15 text-amber-400 border border-amber-500/25",
};

export default function Badge({
  variant = "inactive",
  children,
  className = "",
}) {
  const cls = variants[variant] || variants.inactive;
  return <span className={`badge ${cls} ${className}`}>{children}</span>;
}
